function getUrl () {

  // const baseURL = process.env.REACT_APP_BASE_URL
  let baseURL;
  const localURL = process.env.REACT_APP_BASE_URL_LOCAL
  const netURL = process.env.REACT_APP_BASE_URL_NETWORK
  const deployedURL = process.env.REACT_APP_BASE_URL

  const  winLocalHref = window.location.href;

  if(winLocalHref.includes('localhost')) {
    baseURL = localURL;
  } else if(winLocalHref.includes('rndws-msn.herokuapp.com')) {
    baseURL = deployedURL;
  } else {
    baseURL = netURL;
  }
	
	return baseURL;
}

export default getUrl;


